<template>
  <v-card>
    <v-card-title class="secondary--text">{{title}}</v-card-title>

    <v-card-text>
      <v-row>
        <v-col cols="12" md="4">
          <warehouse-select
            class="rounded-lg"
            :return-object="false"
            label="انبار"
            :items="warehouses"
            v-model="filter_warehouses"
            item-text="title"
            item-value="id"
            multiple
            clearable
            @input="setFilterWithWarehouses"
          >
          </warehouse-select>
        </v-col>

        <v-col cols="12" md="4">
          <v-select
            :menu-props="{ bottom: true, offsetY: true }"
            class="rounded-lg"
            :items="wareLevels"
            v-model="filters.level"
            label="سطح کالا"
            @change="setFilterWithWareLevel"
          />
        </v-col>
        <v-col cols="12" md="4">
          <v-select
            :menu-props="{ bottom: true, offsetY: true }"
            class="rounded-lg"
            :items="waresStatuses"
            v-model="filters.status"
            label="وضعیت کالا"
            @change="setFilterWithWareStatus"
          ></v-select>
        </v-col>
        <v-col cols="12" md="4" class="d-flex justify-center justify-md-end">
          <sort-inventory :datatable="$refs.datatable" />
        </v-col>
        <v-col cols="12" class="all-wares-inventory">
          <m-datatable :api-url="url" :headers="headers" :filters.sync="filters" ref="datatable" :additional-applied-filters="appliedFilters">
            <template #item.inventory="{ item }">
              <open-inventory-btn :wareId="item.id" />
            </template>
          </m-datatable>
        </v-col>
      </v-row>
    </v-card-text>
  </v-card>
</template>

<script>
import _ from "lodash";
import wareApiMixin from "@/mixin/wareApi";
import MDatatable from "@/components/m-datatable";
import OpenInventoryBtn from "@/components/btns/OpenInventoryBtn";
import SortInventory from "./SortInventory.vue";
import WarehouseSelect from "@/components/selects/WarehouseSelect.vue";

export default {
  components: { MDatatable, OpenInventoryBtn, SortInventory, WarehouseSelect },
  mixins: [wareApiMixin],
  data() {
    return {
      filter_warehouses: [0],
      appliedFilters: [],

      url: "reports/inventory/ware/all",
      headers: [
        {
          text: "کد",
          value: "code",
          sortable: false,
        },
        {
          text: "نام",
          value: "name",
          sortable: false,
        },
        {
          text: "واحد",
          value: "unit",
          sortable: false,
          filterable: false,
        },
        {
          text: "مقدار وارده",
          value: "input.count",
          type: "numeric",
          sortable: false,
          filterable: false,
        },
        // {
        //   text: "فی وارده",
        //   value: "input.fee",
        //   type: "numeric",
        //   sortable: false,
        //   filterable: false,
        // },
        {
          text: "مبلغ وارده",
          value: "input.value",
          type: "numeric",
          sortable: false,
          filterable: false,
        },
        {
          text: "مقدار صادره",
          value: "output.count",
          type: "numeric",
          sortable: false,
          filterable: false,
        },
        // {
        //   text: "فی صادره",
        //   value: "output.fee",
        //   type: "numeric",
        //   sortable: false,
        //   filterable: false,
        // },
        {
          text: "مبلغ صادره",
          value: "output.value",
          type: "numeric",
          sortable: false,
          filterable: false,
        },
        {
          text: "مقدار مانده",
          value: "remain.count",
          type: "numeric",
          sortable: false,
          filterable: false,
        },
        // {
        //   text: "فی مانده",
        //   value: "remain.fee",
        //   type: "numeric",
        //   sortable: false,
        //   filterable: false,
        // },
        {
          text: "مبلغ مانده",
          value: "remain.value",
          type: "numeric",
          sortable: false,
          filterable: false,
        },
        {
          text: "کاردکس",
          value: "inventory",
          sortable: false,
          filterable: false,
          hideInExport: true,
        },
      ],
      filters: {
        level: 3,
      },
    };
  },
  created() {
    this.getWarehouses();
  },
  mounted() {
    this.setFilterWithWareLevel()
  },

  methods: {
    setFilterWithWarehouses() {
      this.setWarehouseAppliedFilter(this.filter_warehouses)
      let warehouses_string = this.filter_warehouses.join(",");
      if (warehouses_string != "0") {
        this.filters.warehouse_in = warehouses_string;
      } else {
        this.filters.warehouse_in = undefined;
      }
      this.$refs.datatable.getDataFromApi();
    },
    warehouseName(id) {
      if (id == 0){
        return 'همه انبار ها'
      }
      for (let warehouse of this.warehouses){
        if (warehouse.id == id){
          return warehouse.title
        }
      }
    },
    setFilterWithWareLevel() {
      let filter_set_done = false
      for (let filter of this.appliedFilters){
        if (filter.text == 'سطح کالا  ') {
          filter.value = this.wareLevelName(this.filters.level)
          filter_set_done = true
        }
      }
      if (!filter_set_done){
        this.appliedFilters.push(
            {
              text: 'سطح کالا  ',
              typeText: null,
              value: this.wareLevelName(this.filters.level)
            }
        )
      }

    },
    wareLevelName(value) {
      for (let wareLevel of this.wareLevels){
        if (wareLevel.value == value){
          return wareLevel.text
        }
      }
    },
    setFilterWithWareStatus() {
      let filter_set_done = false
      for (let filter of this.appliedFilters){
        if (filter.text == 'وضعیت کالا  ') {
          filter.value = this.wareStatusName(this.filters.status)
          filter_set_done = true
        }
      }
      if (!filter_set_done){
        this.appliedFilters.push(
            {
              text: 'وضعیت کالا  ',
              typeText: null,
              value: this.wareStatusName(this.filters.status)
            }
        )
      }

    },
    wareStatusName(value) {
      for (let waresStatus of this.waresStatuses){
        if (waresStatus.value == value){
          return waresStatus.text
        }
      }
    },
    setWarehouseAppliedFilter(filteredWarehouses) {
      let value_string = ''
      let filter_set_done = false
      for (let warehouse of filteredWarehouses){
        value_string += this.warehouseName(warehouse)
      }
      for (let filter of this.appliedFilters){
        if (filter.text == 'انبار  ') {
          filter.value = value_string
          filter_set_done = true
        }
      }
      if (!filter_set_done){
        this.appliedFilters.push(
            {
              text: 'انبار  ',
              typeText: null,
              value: value_string,
            }
        )
      }

    },
  },
  computed: {
    title() {
      return this.setDocumentTitle('کاردکس همه کالا ها')
    },
  }
  };
</script>

<style lang="scss">
.all-wares-inventory div.v-data-table__wrapper table {
  tbody td,
  thead th {
    &:nth-child(6),
    &:nth-child(8),
    &:nth-child(10),
    &:nth-child(12),
    &:nth-child(14) {
      border-right: 1px solid #e0e0e0 !important;
    }
  }
}
</style>
